var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchActive = function SvgSearchActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "M10.593 18.352a8.26 8.26 0 1 0 0-16.519 8.26 8.26 0 0 0 0 16.519M20.657 17.37c-.302-.558-.944-.87-1.805-.87-.651 0-1.21.266-1.54.724-.33.459-.404 1.073-.202 1.687.394 1.191 1.082 1.457 1.457 1.503.055.01.11.01.175.01.403 0 1.026-.175 1.631-1.082.486-.706.578-1.412.284-1.971"
  })));
};
export default SvgSearchActive;